export const TICKET_ACTION = {
  PENDING_TICKET: 'PENDING_TICKET',
  REQUEST_CLOSE_TICKET: 'REQUEST_CLOSE_TICKET',
  TICKET_ASSIGN: 'TICKET_ASSIGN',
  TICKET_TRANSFER: 'TICKET_TRANSFER',
}

export const REPORT_MIN_YEAR = 2020
export const REPORT_MAX_YEAR = 2050
